<button type="button"
  class="flex bg-orange items-center text-xs text-white font-semibold uppercase rounded-full px-2 sm:px-4 py-2 w-max transition delay-75 duration-200 hover:scale-110"
  transloco="btn-vn.log-in" (click)="navigateToLogin()"></button>